import { IconButton } from "@mui/material";
import BadgeIcon from "@mui/icons-material/BadgeOutlined";
import MenuIcon from "@mui/icons-material/Menu";
import React from "react";
import { Routes } from "../../../routes";
import { useLocation, useNavigate } from "react-router-dom";
import { useGetAccess } from "../../../common/hooks/useGetAccess/useGetAccess";
import { OdinAccess } from "../../../common/enums";
import DevicesIcon from "@mui/icons-material/Devices";
import DashboardIcon from "@mui/icons-material/Dashboard";
import { AppHeaderOptionItem } from "./optionItem/AppHeaderOptionItem";
import { useTranslation } from "react-i18next";

type Props = {
  menuId: string;
  handleProfileMenuOpen: (e: React.MouseEvent<HTMLElement>) => void;
};

export const AppHeaderOptions = ({ menuId, handleProfileMenuOpen }: Props) => {
  const history = useNavigate();
  const location = useLocation();
  const { hasAccess: isDeviceSetupAvailable } = useGetAccess(OdinAccess.DEVICE_SETUP);
  const { hasAccess: isDashboardAvailable } = useGetAccess(OdinAccess.SHOW_STATISTICS);
  const { t } = useTranslation("common");

  const onDevicesClick = () => {
    history(Routes.devices);
  };

  const onBadgesClick = () => {
    history(Routes.badges);
  };

  const onDashboardClick = () => {
    history(Routes.homepage);
  };

  const isDashboardActive = location.pathname === Routes.homepage;
  const isBadgesActive = location.pathname === Routes.badges;
  const isDevicesActive = location.pathname === Routes.devices;

  return (
    <>
      <AppHeaderOptionItem
        dataTestId="header-dashboard-item"
        disabled={!isDashboardAvailable}
        isActive={isDashboardActive}
        title={t("headTitles.dashboard")}
        onIconClick={onDashboardClick}
      >
        <DashboardIcon color={isDashboardAvailable ? "primary" : "disabled"} />
      </AppHeaderOptionItem>

      <AppHeaderOptionItem dataTestId="header-badges-item" isActive={isBadgesActive} title={t("headTitles.badges")} onIconClick={onBadgesClick}>
        <BadgeIcon color="primary" />
      </AppHeaderOptionItem>

      <AppHeaderOptionItem
        dataTestId="header-devices-item"
        disabled={!isDeviceSetupAvailable}
        isActive={isDevicesActive}
        title={t("headTitles.devicesSimplified")}
        onIconClick={onDevicesClick}
      >
        <DevicesIcon color={isDeviceSetupAvailable ? "primary" : "disabled"} />
      </AppHeaderOptionItem>

      <IconButton sx={{ mr: 1 }} onClick={handleProfileMenuOpen} data-testid="header-menu-button">
        <MenuIcon color="primary" aria-controls={menuId} aria-haspopup="true" />
      </IconButton>
    </>
  );
};
